import { memo } from 'react';
import styles from './index.module.scss';
import titlePng from '@/assets/images/title_icon.png';
import { useRequest } from 'ahooks';
import { apiV2ElectricMapDataStrategyListPost } from '@maxtropy/device-customer-apis-v2';
import { Empty } from '@maxtropy/components';
import dayjs from 'dayjs';
import { isNil } from 'lodash-es';
import classNames from 'classnames';

interface StrategyRecordProps {
  isCompactMode?: boolean;
}

const StrategyRecord: React.FC<StrategyRecordProps> = ({ isCompactMode }) => {
  const { data: recordData, loading: recordLoading } = useRequest(() =>
    apiV2ElectricMapDataStrategyListPost({}).then(res => {
      return res.list;
    })
  );

  return (
    <div className={classNames(styles.record, isCompactMode && styles.compactRecord)}>
      <div className={styles.titleHeader}>
        <img src={titlePng} alt="" />
        <div>策略记录</div>
      </div>
      <div className={styles.recordContent}>
        {(recordData ?? []).length > 0 ? (
          (recordData ?? []).map((item, index) => (
            <div className={styles.recordItem} key={index}>
              <div className={styles.circle}></div>
              <div className={styles.content}>{item.content}</div>
              <div className={styles.time}>{isNil(item.ts) ? '--' : dayjs(item.ts).format('YYYY-MM-DD HH:mm:ss')}</div>
            </div>
          ))
        ) : (
          <div className={classNames(styles.status, styles.empty_wrapper)}>
            <div className={styles.outerCircle}>
              <div className={styles.rotateRing}></div>
              <div className={styles.innerDiamonds}></div>
            </div>
            <div>本月全厂供电系统整体运行平稳，系统安全可靠。</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(StrategyRecord);
